export const status = {
  SHOULD_CALL_API: 'SHOULD_CALL_API',
  FETCHING: 'FETCHING',
  SUBMITING: 'SUBMITING',
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
};

export const searchQueryMinLength = 3;

export const supportedCountriesIds = [1, 2, 4, 241];

export const globalCountryId = 241;
